import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorDialogComponent } from 'src/app/dialog/error-dialog/error-dialog.component';
import { AlertRoot } from '../../models/alert-root';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { v4 as uuidv4 } from 'uuid';

@Component({
    selector: 'popup',
    templateUrl: './alert-oncall-dialog.component.html',
    styleUrls: ['./alert-oncall-dialog.component.css'],
    standalone: false
})
export class AlertOnCallDialogComponent implements OnInit {
  commentInput: string = '';
  teamName: string = '';
  userSendingAlert: string = '';
  commentFormGroup: FormGroup;

  constructor(private dialogRef: MatDialogRef<AlertOnCallDialogComponent>,
    private dialog: MatDialog,
    @Inject(FormBuilder) private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.teamName = data.teamToAlert;
    this.userSendingAlert = data.userSendingAlert;
    this.commentFormGroup = this.fb.group({
        comment: [this.commentInput, [Validators.required]],
      });
  }

  ngOnInit(): void {
    this.commentFormGroup.get('comment')?.valueChanges.subscribe(value => {
      this.commentInput = value;
    });
    this.commentFormGroup.patchValue({ comment: `${this.userSendingAlert} needs help` });
    console.log("Inside Popup Component");
  }

  sendAlert(description: string):void {
    let alertBody = this.createAlert(description);
    this.dialogRef.close({ teamName: this.teamName, alertBody: alertBody });
  };

  closePopup(confirmed: boolean):void {
    this.dialogRef.close(confirmed);
    console.log('Closing popup');
  }

  createAlert(description: string): any {
    let alertId = uuidv4();
    let generatedAlert: AlertRoot = {
        Data: {
            Essentials: {
                AlertId: alertId,
                AlertRule: description,
                MonitorCondition: "Fired",
                Severity: "1",
                Description: description,
                AlertTargetIds:["Portal Generated Alert"]
            }
        }
    }
    return generatedAlert;
  }

  handleError(error: HttpErrorResponse, message: string): void {
    this.openErrorDialog(`${message}: ${error.status} ${error.statusText}`);
  }

  openErrorDialog(errorMessage: string): void {
    this.dialog.open(ErrorDialogComponent, {
      data: { message: errorMessage }
    });
  }
}